import { useBoolean } from 'usehooks-ts';

import { MediaPlayer } from './MediaPlayer';
import { VideoThumbnail } from './VideoThumbnail';
import { MediaVideoProps } from '.';

export const MediaVideo = ({
	source,
	style,
	autoPlay,
	resizeMode,
	playerVisible,
}: MediaVideoProps) => {
	const { value: displayPlayer, setTrue: showPlayer } = useBoolean(false);

	if (!displayPlayer && source.thumbnailUrl) {
		return <VideoThumbnail source={source} onPress={showPlayer} style={style} />;
	}

	return (
		<MediaPlayer
			source={source}
			style={style}
			autoPlay={autoPlay}
			resizeMode={resizeMode}
			playerVisible={playerVisible}
		/>
	);
};
